import React from "react";
import { Pill } from "../ResultsPrimitives.jsx";

export default function ReassignmentLoadingState({ showRouteImpact }) {
  const title = showRouteImpact
    ? "Simulation globale des tournées en cours"
    : "Analyse des camions compatibles en cours";
  const subtitle = showRouteImpact
    ? "On reconstruit les tournées source et cible pour estimer l'impact global du transfert."
    : "On filtre les camions déplaçables et on prépare les indicateurs utiles à la décision rapide.";
  const stages = showRouteImpact
    ? ["Lecture du planning", "Simulation du transfert", "Comparaison flotte"]
    : ["Filtrage compatibilité", "Lecture camion", "Préparation de la vue"];

  return (
    <div
      aria-live="polite"
      className="mb-4 overflow-hidden rounded-2xl border border-border-accent-subtle bg-surface shadow-none"
      role="status"
    >
      <div className="flex flex-wrap items-center gap-4 px-4 py-4 lg:px-5">
        <div className="relative flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl border border-border-accent-subtle bg-surface-muted shadow-none">
          <span className="absolute inset-2 rounded-full border-2 border-dashed border-accent/25 animate-spin" />
          <span className="absolute inset-[0.95rem] rounded-full border border-accent/10" />
          <span className="relative h-3.5 w-3.5 rounded-full bg-accent ring-6 ring-accent/10 animate-pulse" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <Pill tone="soft" className="bg-accent px-3 py-1 text-[0.64rem] font-semibold uppercase tracking-[0.18em] text-white shadow-soft">
              Traitement en cours
            </Pill>
            <span className="text-xs font-medium text-muted-strong">
              La fenêtre travaille activement
            </span>
          </div>
          <p className="mt-2 text-base font-semibold text-text">
            {title}
          </p>
          <p className="mt-1 text-sm leading-6 text-muted-strong">
            {subtitle}
          </p>
          <div className="mt-3 h-2 overflow-hidden rounded-full bg-surface-muted ring-1 ring-border-accent-subtle">
            <div className="h-full w-2/5 rounded-full bg-accent" />
          </div>
        </div>
      </div>
      <div className="border-t border-border-accent-subtle bg-surface-muted px-4 py-3 lg:px-5">
        <div className="flex flex-wrap gap-2">
          {stages.map((stage) => (
            <Pill
              key={stage}
              tone="outline"
              className="gap-2 bg-white px-3 py-1.5 text-xs font-medium text-muted-strong shadow-none"
            >
              <span className="h-2 w-2 rounded-full bg-accent animate-pulse" />
              {stage}
            </Pill>
          ))}
        </div>
        <div className="mt-3 grid gap-2">
          {Array.from({ length: 3 }).map((_, index) => (
            <div
              key={`loader-row-${index}`}
              className="rounded-xl border border-line-soft bg-white px-3 py-3"
            >
              <div className="h-3 w-40 rounded-full bg-neutral-soft" />
              <div className="mt-3 flex flex-wrap gap-2">
                <div className="h-9 w-28 rounded-full bg-neutral-soft" />
                <div className="h-9 w-28 rounded-full bg-neutral-soft" />
                <div className="h-9 w-28 rounded-full bg-neutral-soft" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
